import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { placements } from "../api/placements";
import type { PlacementCreateCommand } from "../api/types";
import { ApiError } from "../api/client";
import { PlacementForm } from "./PlacementForm";

export function PlacementsPage() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const list = useQuery({ queryKey: ["placements"], queryFn: placements.list });
  const create = useMutation({
    mutationFn: placements.create,
    onSuccess: async (placement) => {
      await queryClient.invalidateQueries({ queryKey: ["placements"] });
      navigate(`/placements/${placement.id}`);
    },
    onError: (failure) => setError(failure instanceof ApiError && failure.status === 409 ? "Такой ключ уже существует." : "Плейсмент не сохранён. Проверьте поля."),
  });

  function submit(command: PlacementCreateCommand) {
    setError(null);
    create.mutate(command);
  }

  return (
    <>
      <div className="page-heading">
        <div><h2>Плейсменты</h2><p className="muted">Форматы, доступные ресурсам и SDK.</p></div>
        <button className="primary" type="button" onClick={() => setCreating((value) => !value)}>{creating ? "Закрыть форму" : "Создать плейсмент"}</button>
      </div>
      {creating && <><PlacementForm busy={create.isPending} submitLabel="Создать" onSubmit={submit} />{error && <p className="error" role="alert">{error}</p>}</>}
      <div className="panel" style={{ marginTop: 16 }}>
        {list.isLoading && <p className="muted">Загружаю…</p>}
        {list.isError && <p className="error">Не удалось загрузить плейсменты. <button type="button" onClick={() => void list.refetch()}>Повторить</button></p>}
        {list.data?.length === 0 && <p className="muted">Плейсментов пока нет.</p>}
        {list.data && list.data.length > 0 && (
          <table>
            <thead><tr><th>Название</th><th>Ключ</th><th>Цели</th><th>Геометрия</th><th>Статус</th><th>Ревизия</th></tr></thead>
            <tbody>{list.data.map((placement) => (
              <tr key={placement.id}>
                <td><Link to={`/placements/${placement.id}`}>{placement.displayName}</Link></td>
                <td><code>{placement.placementKey}</code></td>
                <td>{placement.targets.map((target) => `${target.resource}/${target.platform}`).join(", ")}</td>
                <td>{placement.layout.aspectRatio}:1</td>
                <td>{placement.status}</td>
                <td>{placement.currentRevision}</td>
              </tr>
            ))}</tbody>
          </table>
        )}
      </div>
    </>
  );
}
